






import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import * as PDFObject from 'pdfobject';

@Component
export default class PrintDialog extends Vue {
    visible = false;
    @Prop() title!: string;
    @Prop() url!: string;

    @Watch('url') onUrlChanged(newUrl: string) {
        this.visible = true;
        this.$nextTick(() => {
            PDFObject.embed(newUrl, '#pdf');
        });
    }

}
